import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare, faChartLine } from "@fortawesome/free-solid-svg-icons";
import { DateRangeSelector } from "./DateRangeSelector";
import { DateRange } from "../dateRangePresets";

interface Props {
  range: DateRange;
  onRangeChange: (next: DateRange) => void;
}

const CLARITY_URL =
  "https://clarity.microsoft.com/projects/view/w4y1vagy0u/impressions?date=Last%203%20days";

export function StatisticsHeader({ range, onRangeChange }: Props) {
  return (
    <header className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-10">
      <div className="flex items-start gap-4">
        <div className="hidden md:flex h-12 w-12 rounded-xl bg-primary-10 items-center justify-center text-primary-100 text-lg">
          <FontAwesomeIcon icon={faChartLine} />
        </div>
        <div>
          <span className="text-xxs uppercase tracking-[0.22em] text-gray-600 font-semibold">
            Admin overview
          </span>
          <h1 className="text-4xl font-bold text-black tracking-tight leading-none mt-2">
            Statistics
          </h1>
          <p className="text-sm text-gray-600 mt-2 max-w-xl">
            A live look at platform health — orders, designs, approvals and web
            traffic across the selected window.
          </p>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center gap-3 lg:gap-4">
        <DateRangeSelector value={range} onChange={onRangeChange} />
        <a
          href={CLARITY_URL}
          target="_blank"
          rel="noreferrer noopener"
          className="inline-flex items-center justify-center gap-2 rounded-full border border-borderGray bg-white px-5 py-2 text-xs font-semibold tracking-wider uppercase text-black hover:bg-gray-100 hover:shadow-md transition-all"
        >
          Open Clarity
          <FontAwesomeIcon
            icon={faArrowUpRightFromSquare}
            className="text-[10px]"
          />
        </a>
      </div>
    </header>
  );
}
